var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElizaShipRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 583.52 286.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#031f54;}.cls-2{fill:#001c56;}.cls-3{fill:#001c57;}.cls-4{fill:#000e26;}.cls-5{fill:#ffc97a;}.cls-6{fill:#ffc055;}.cls-7{fill:#fc75ac;}.cls-8{fill:#feca7a;}.cls-9{fill:#7e6dac;}.cls-10{fill:#021e54;}.cls-11{fill:#33347e;}.cls-12{fill:#c5c3ed;}.cls-13{fill:#d8417d;}.cls-14{fill:#5667a4;}.cls-15{fill:#4e4597;}.cls-16{fill:#4f166b;}.cls-17{stroke:#1b1464;}.cls-17,.cls-18{stroke-width:.71px;}.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22{fill:none;stroke-miterlimit:10;}.cls-18{stroke:#001c57;}.cls-19{stroke:#33347e;}.cls-20{stroke-linecap:round;}.cls-20,.cls-21{stroke:#4f166b;stroke-width:1.18px;}.cls-22{stroke:#b3d2ff;stroke-width:.94px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M261.04,206.83h0c1.42,2.2,3.79,3.6,6.4,3.81l28.54,2.22c1.11,.09,1.45-1.47,.4-1.85l-15.89-5.84c-3.68-1.35-4.97-5.89-2.57-8.98l1.14-1.46h0c-5.99-6.9-17.3-3.88-19.06,5.09l-.16,.83c-.42,2.14,0,4.36,1.2,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.18,125.06c0-18.97,41.36-34.34,92.37-34.34,51.02,0,92.37,15.37,92.37,34.34,0,50.28-41.36,91.04-92.37,91.04s-92.37-40.76-92.37-91.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M206.86,92.59l5.65,19.01c.7,2.36,4.04,2.36,4.74,0l5.65-19.01c4.06-13.66,6.12-27.84,6.12-42.1v-6.79h-28.28v6.79c0,14.25,2.06,28.43,6.12,42.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 215.15,
    cy: 47.3,
    rx: 17.06,
    ry: 6.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 198.09,
    y: 30.24,
    width: 34.08,
    height: 17.06,
    transform: "translate(430.26 77.54) rotate(-180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 215.15,
    cy: 30.24,
    rx: 17.06,
    ry: 6.43
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M232.21,30.24c0,3.55-7.64,6.43-17.06,6.43-9.42,0-17.06-2.88-17.06-6.43,0-9.42,7.64-17.06,17.06-17.06,9.42,0,17.06,7.64,17.06,17.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M90.62,171.3l99.55-11.73c.32-.04,.64-.09,.97-.13,61.75-8.41,124.65-.52,182.23,23.31,.88,.36,1.76,.73,2.64,1.1,18.88,7.94,36.52,18.57,52.46,31.43l12.52,10.11,29.43-4.56-33.88-27.04c-4.11-2.99-12.24-11.28-15.9-14.8-29.6-28.51-9.32-69.62,42.21-81.13l46.05-12.61-9.72-11.66-68.67,10.02c-26.38,3.05-74.92,6.58-74.92,6.58-42.03,1.83-88.08-6.58-117.68-30.33-.42-.34-8.95-8.77-8.95-8.77h0c-5.3,2.65-13.7,3.47-21.01,2.01l-4.75-1.19,1.57,1.75c6.15,6.85,6.17,16.9,8.58,27.06,6.87,29.03-11.88,51.72-51.55,60.64l-73.9,14.07,2.74,15.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.42,206.33l6.9,23.21c.86,2.88,4.93,2.88,5.79,0l6.9-23.21c4.96-16.68,7.48-34,7.48-51.4v-8.29h-34.54v8.29c0,17.41,2.52,34.72,7.48,51.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 83.54,
    cy: 151.02,
    rx: 20.83,
    ry: 7.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 62.71,
    y: 130.19,
    width: 41.61,
    height: 20.83,
    transform: "translate(167.03 281.21) rotate(-180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 83.54,
    cy: 130.19,
    rx: 20.83,
    ry: 7.86
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M104.37,130.19c0,4.34-9.33,7.86-20.83,7.86-11.5,0-20.83-3.52-20.83-7.86,0-11.5,9.33-20.83,20.83-20.83,11.5,0,20.83,9.33,20.83,20.83Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M445.33,260.73l6.9,23.21c.86,2.88,4.93,2.88,5.79,0l6.9-23.21c4.96-16.68,7.48-34,7.48-51.4v-8.29h-34.54v8.29c0,17.41,2.52,34.72,7.48,51.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 455.44,
    cy: 205.42,
    rx: 20.83,
    ry: 7.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 434.61,
    y: 184.59,
    width: 41.61,
    height: 20.83,
    transform: "translate(910.83 390.01) rotate(-180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 455.44,
    cy: 184.59,
    rx: 20.83,
    ry: 7.86
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M476.27,184.59c0,4.34-9.33,7.86-20.83,7.86-11.5,0-20.83-3.52-20.83-7.86,0-11.5,9.33-20.83,20.83-20.83,11.5,0,20.83,9.33,20.83,20.83Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 317.39,
    cy: 117.4,
    rx: 59.75,
    ry: 16.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 215.33,
    cy: 29.59,
    rx: 70.17,
    ry: 19.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M177.34,16.54c-16.55,2.98-27.2,7.63-27.2,12.87,0,5.01,9.74,9.48,25.07,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M187.52,19.65c-16.8,.76-32.09,6.01-32.64,10.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M252.57,42.05c16.55-2.98,27.2-7.63,27.2-12.87,0-5.01-9.74-9.48-25.07-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M242.39,38.93c16.8-.76,32.09-6.01,32.64-10.12"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M280.84,107.71l79.49,4.39,12.84-41.53c2.93-9.49-3.9-19.2-13.83-19.64l-72.75-3.19c-10.04-.44-17.73,8.83-15.44,18.62l9.69,41.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M244.65,65.1c0,2.05-4.41,3.72-9.86,3.72-5.44,0-9.86-1.66-9.86-3.72,0-5.44,4.41-9.86,9.86-9.86s9.86,4.41,9.86,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M239.32,64.66c0,.9-1.93,1.63-4.32,1.63-2.38,0-4.32-.73-4.32-1.63,0-2.38,1.93-4.32,4.32-4.32,2.38,0,4.32,1.93,4.32,4.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 308.35,
    cy: 71.5,
    rx: 6.62,
    ry: 16.17,
    transform: "translate(6.77 167.64) rotate(-30.74)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 351.24,
    cy: 67.03,
    rx: 21.19,
    ry: 8.68,
    transform: "translate(95.47 316.92) rotate(-55.14)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M212.07,17.83c-.61-.98-1.34-1.87-2.1-2.73-.35-.4-1.57-1.72-2.03-1.44-.54,.33,.65,2.09,.81,2.3,1.7,2.29,1.89,3.46,2.18,4.47-.52-.77-3.28-4.53-3.8-4.96-.28-.23-1.74-1.39-1.74-.42,0,.23,.25,.64,.81,1.45,.76,1.1,2.8,4.87,2.79,5.39-.93-.65-2.62-3.62-3.58-4.22-.45-.28-2.01-1.89-2.49-.96-.21,.41,1.12,1.97,1.49,2.33,.78,.77,1.77,3,2.44,4.04-.81-.34-3.78-4.03-4.61-4.3-.4-.13-.91,.24-.67,.92,.1,.29,7.46,9.37,8.65,10.4,0,0,.74,.74,1.7,1.57,.27,.23,.74,.42,1.07,.52,2.65,.74,4.82-2.24,3.4-4.61-.11-.18-.23-.35-.36-.52-.84-1.07-2.8-7.37-3.97-9.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.65,73.71c-15.16,4.06-30.17,6.46-45.71,2.7-14.07-3.41-28.13-15.81-37.3-26.72-5.73-6.82-16.36-18.85-16.36-18.85l5.58-4.56s10.99,11.5,16.02,16.29c4.43,4.21,9.51,8.41,14.36,12.13-.44-.33-.87-.67-1.31-1,4.8,3.65,9.92,6.87,15.49,9.2-.52-.21-1.03-.43-1.55-.64,4.15,1.7,8.47,2.84,12.91,3.42-.57-.07-1.14-.14-1.72-.21,6.36,.79,12.78,.47,19.11-.44-.57,.08-1.14,.17-1.71,.25,6.3-.93,12.5-2.41,18.65-4.06,3.26-.87,7.16,.99,7.97,4.46,.79,3.37-.95,7.12-4.44,8.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M214.45,26.8c1.09-2.51,2.18-5.02,3.27-7.52,.39-.88,.4-2.37-.56-2.32-.3,.02-.56,.22-.79,.43-1.79,1.68-2.7,4.07-3.55,6.37-.26,.71-.53,1.47-.34,2.2,.19,.73,1.05,1.32,1.71,.94"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M300.07,57.43h0c1.87,1.75,7,3.67,10,9.29,3.81,7.12,5.38,18.01,5.38,18.01,0,0,9.35-14.91,1.74-24.43h0c-6.41-8.85-17.13-2.87-17.13-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M347.48,68.41c2.01,9.28-1.19,17.67-7.49,29.66-2.03,3.87,31.29,21.29,31.29,21.29-10.6,16.4-35.5,18.64-35.5,18.64-11.3-2.78-19.39-15.75-22.01-23.68,0,0,1.92-4.56,3.2-6.82,0,0,2.42-10.2-3.38-17.24-8.4-10.2-5.1-15.81-3.48-20.18,5.91-15.95,16.08-19.38,27.45-13.26,0,0,7.91,2.37,9.91,11.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M320.28,83.51l.72-1.23c6.46-11.04,14.72-20.92,24.43-29.25h0c-10.91-5.55-23.95-4.85-34.21,1.83l-1.63,1.06,10.68,27.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M320.28,83.51l2.98-11.52c1.53-4.75,4.94-10.57,7.97-14.53,1.18-1.55,2.72-3.04,5.79-5.22h0c-7.31-2.82-12.99-2.69-20.14,1.26h0c.06,6.34,.6,12.68,1.61,18.94l1.79,11.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M324.27,56.82c.29,2.63,3.45,.86,4.65-.92,2.38-3.49,2.46-5.12,2.46-5.12h0c.26,1.21-4.41-10.92-4.41-10.92l-7.08,4.03h0c2.68,3.08,3.87,8.29,4.37,12.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M320.2,83.04h0c-.66,4.68,.03,6.24,1.75,13.81l.2,.49"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M327.39,101.81c1.26-.16,7.75,.37,12.6-3.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M316.7,101.74s1.13,.71,2.92,.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 323.54,
    cy: 101.57,
    rx: 3.78,
    ry: 3.9,
    transform: "translate(-12.83 58.54) rotate(-10.14)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M346.95,39.06c-1.51,4.82-8.84,8.22-15.13,5.83-4.86-1.85-8.44-4.83-9.46-8.9h0c4.27,1.79,9.01,2.14,13.5,1.01l2.46-.62c1.42,5.28,7.42,3.71,8.63,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M304.46,17.54c-2.55,3.37-.98,8.81,2.11,10.56,1.16,.66,8.57,5.54,17.23-7.05,.86-1.24,1.99-4.04,1.31-5.7-.31-.77-1.13-1.6-1.91-1.89-1.35-.51-2.32,.36-3.39,1.84,0,0-1.67,3.87-6.53,5.96-6.09,2.62-9.31-3.21-8.82-3.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M305.75,24.53c-2.33,1.41-4.45-.68-4.27-1.03-1.77,3.97,7.22,19.8,26.59,15.79,7.72,3.51,18.02,1.16,22.14-5.31,1.97-3.1,1.86-8.04,1.86-8.04-.11,.2-1.82,3.03-3.77,2.74-2.28-.35-4.69-.55-3.14-7.27,1.77-7.65-2.27-13.98-6.28-16.68-11.89-8-24.2-4.18-27.92-.56-5.29,5.14-5.35,9.92-5,12.71,.15,1.22,.43,2.41,.81,3.58,.7,2.19,2.02,2.24-1.03,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M309.15,12.83c-3.19,4.92-4.11,13.33-4.41,14.65-2.16,9.29,2.17,20.12,2.88,21.03,0,0,7.24-.11,15.19-3.24,3.26-1.29,6.58-3.92,9.58-5.9,1.11,.85,2.66,1.34,3.99,.74,3.16-1.41,4.15-4.8,3.09-6.65-.4-.7-1.03-1.29-1.81-1.54-.15-.05-6.75,1.06-10.15-2.84-6.23-7.17,1.87-18.16-10.72-16.8-.51,.05-1.33-.39-1.33-.39l-1.45-.58c-1.78-.72-3.82-.08-4.86,1.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "310.99 26.81 306.55 34.01 310.45 35.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.25,38.52c.66,4.95,7.33,6.86,10.94,1.41l-10.94-1.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M350.19,23.29c-.09,3.47-3.88,6.14-6.75,5.69-1.08-.17-8.33-.84-7.43-13.33,.09-1.24,.79-3.6,2.07-4.32,.6-.34,1.54-.45,2.19-.24,1.12,.36,1.3,1.42,1.23,2.92,0,0-.91,3.33,1.14,7.15,2.56,4.79,7.61,2.7,7.55,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M317.81,20.11c-3.04,1.66-7.26-.28-8.3-3-.39-1.02-3.44-7.63,7.81-13.11,1.11-.54,3.52-1.12,4.78-.37,.59,.35,1.16,1.11,1.3,1.78,.25,1.15-.58,1.84-1.91,2.53,0,0-3.34,.88-5.62,4.57-2.87,4.62,1.47,7.94,1.94,7.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M330.82,22.38c-4.99,3.82-13.81-3.15-14.25-7.93-.17-1.8-4.68-8.77,13.66-11.61,1.81-.28,5.5,.04,7.02,1.86,.71,.85,1.23,2.32,1.18,3.44-.09,1.93-1.55,2.58-3.73,2.98,0,0,1.38-3.16-3.35,1.44-5.93,5.76-1.34,10.1-.54,9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M308.99,41.82c1.81,1.62,4.67,1.96,7.1,.29-1.32-1.27-5.37-1.51-7.1-.29Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 310.18,
    cy: 25.94,
    rx: 2.6,
    ry: 1.43,
    transform: "translate(236.04 328.24) rotate(-81)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 320.98,
    cy: 28.64,
    rx: 2.6,
    ry: 1.43,
    transform: "translate(208.18 330.51) rotate(-74.61)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M327.02,96.92c-.57-.59-1.21-1.1-1.87-1.58-.31-.23-1.35-.96-1.63-.7-.33,.3,.76,1.35,.9,1.47,1.52,1.34,1.83,2.11,2.18,2.77-.48-.45-2.95-2.65-3.38-2.87-.23-.12-1.42-.71-1.28-.03,.03,.16,.27,.4,.78,.88,.69,.65,2.67,2.96,2.73,3.32-.74-.31-2.36-2.12-3.12-2.39-.35-.13-1.68-1.01-1.88-.3-.09,.32,1.07,1.19,1.38,1.39,.65,.42,1.68,1.81,2.3,2.43-.61-.12-3.23-2.23-3.85-2.3-.29-.03-.6,.3-.34,.73,.11,.18,6.58,5.38,7.56,5.92,0,0,.63,.4,1.42,.83,.22,.12,.58,.18,.82,.2,1.96,.13,3.04-2.25,1.7-3.68-.1-.11-.21-.21-.32-.3-.75-.62-3.04-4.68-4.12-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M330.03,102.19l-.26-4.55c-.03-.53-.4-1.28-.86-1.01-.15,.08-.23,.25-.28,.41-.47,1.28-.33,2.69-.18,4.04,.05,.42,.1,.86,.38,1.18s.86,.39,1.09,.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M329.27,107.19c8.27,6.89,16.52,10.52,20.64,12.21,12.6,5.17,25.09,1.67,29.41-1.6,6.4-4.83,8.2-8.96,8.91-14.15,2.89-21.21-23.11-41.29-32.31-47.1-2.09-1.32-8.57-4.86-11.95-2.02-.14,.12-5.55,5.15,4.19,11.07,1.87,1.14,31.99,17.17,31.48,35.75-.2,7.37-4.42,10.16-6.52,11.37-4.88,2.83-16.9,4.62-32.12-4.12-1.46-.84-5.18-3.08-9.35-6.03l-2.39,4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M346.74,83.53l.02-.39c2.38-12.87,7.33-25.04,14.78-34.32h0s-12.45-.96-20.94,8.06h0c-7.97,7.71,6.14,26.64,6.14,26.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505.27,118.18l5.65,19.01c.7,2.36,4.04,2.36,4.74,0l5.65-19.01c4.06-13.66,6.12-27.84,6.12-42.1v-6.79h-28.28v6.79c0,14.25,2.06,28.43,6.12,42.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 513.55,
    cy: 72.89,
    rx: 17.06,
    ry: 6.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 496.49,
    y: 55.83,
    width: 34.08,
    height: 17.06,
    transform: "translate(1027.06 128.72) rotate(-180)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 513.55,
    cy: 55.83,
    rx: 17.06,
    ry: 6.43
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M530.61,55.83c0,3.55-7.64,6.43-17.06,6.43-9.42,0-17.06-2.88-17.06-6.43,0-9.42,7.64-17.06,17.06-17.06,9.42,0,17.06,7.64,17.06,17.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M360.53,131.39c0,6.3-22.3,11.41-49.81,11.41-27.51,0-49.81-5.11-49.81-11.41,0-16.71,22.3-30.25,49.81-30.25,27.51,0,49.81,13.54,49.81,30.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M438.71,90.16c0,2.05-4.41,3.72-9.86,3.72-5.44,0-9.86-1.66-9.86-3.72,0-5.44,4.41-9.86,9.86-9.86,5.44,0,9.86,4.41,9.86,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M433.38,89.72c0,.9-1.93,1.63-4.32,1.63-2.38,0-4.32-.73-4.32-1.63,0-2.38,1.93-4.32,4.32-4.32,2.38,0,4.32,1.93,4.32,4.32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M405.46,170.57c0,3.35-7.2,6.06-16.07,6.06-8.88,0-16.07-2.71-16.07-6.06,0-8.88,7.2-16.07,16.07-16.07,8.88,0,16.07,7.2,16.07,16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M399.88,168.67c0,2.12-4.55,3.83-10.15,3.83-5.61,0-10.15-1.71-10.15-3.83,0-5.61,4.55-10.15,10.15-10.15,5.61,0,10.15,4.55,10.15,10.15Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M213.22,139.76c0,3.35-7.2,6.06-16.07,6.06-8.88,0-16.07-2.71-16.07-6.06,0-8.88,7.2-16.07,16.07-16.07s16.07,7.2,16.07,16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.1,137.69c0,2.21-4.75,4-10.61,4-5.86,0-10.61-1.79-10.61-4,0-5.86,4.75-10.61,10.61-10.61,5.86,0,10.61,4.75,10.61,10.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M406.93,97.85c0,31.13-41.36,56.37-92.37,56.37-51.02,0-92.37-25.24-92.37-56.37"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 512.88,
    cy: 55.73,
    rx: 70.17,
    ry: 19.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M474.89,42.67c-16.55,2.98-27.2,7.63-27.2,12.87s9.74,9.48,25.07,12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M485.07,45.78c-16.8,.76-32.09,6.01-32.64,10.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M550.12,68.18c16.55-2.98,27.2-7.63,27.2-12.87,0-5.01-9.74-9.48-25.07-12.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M539.94,65.07c16.8-.76,32.09-6.01,32.64-10.12"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 455.44,
    cy: 183.36,
    rx: 83.07,
    ry: 23.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M410.47,167.91c-19.59,3.52-32.2,9.04-32.2,15.23,0,5.93,11.53,11.23,29.68,14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M422.52,171.6c-19.88,.9-37.99,7.12-38.64,11.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M499.53,198.11c19.59-3.52,32.2-9.04,32.2-15.23,0-5.93-11.53-11.23-29.68-14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M487.48,194.42c19.88-.9,37.99-7.12,38.64-11.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 83.54,
    cy: 130.19,
    rx: 83.07,
    ry: 23.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M38.56,114.73c-19.59,3.52-32.2,9.04-32.2,15.23,0,5.93,11.53,11.23,29.68,14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M50.61,118.42c-19.88,.9-37.99,7.12-38.64,11.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M127.62,144.93c19.59-3.52,32.2-9.04,32.2-15.23,0-5.93-11.53-11.23-29.68-14.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M115.57,141.25c19.88-.9,37.99-7.12,38.64-11.98"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M345.05,214.61h0c1.42,2.2,3.79,3.6,6.4,3.81l28.54,2.22c1.11,.09,1.45-1.47,.4-1.85l-15.89-5.84c-3.68-1.35-4.97-5.89-2.57-8.98l1.14-1.46h0c-5.99-6.9-17.3-3.88-19.06,5.09l-.16,.83c-.42,2.14,0,4.36,1.2,6.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 238.41,
    y: 84.08,
    width: 4.26,
    height: 17.32,
    transform: "translate(498.09 103.78) rotate(161.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 237.72,
    cy: 84.4,
    r: 5.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M258.27,114.63c0,3.55-6.47,6.42-14.44,6.42-7.98,0-14.44-2.87-14.44-6.42,0-9.4,6.47-17.02,14.44-17.02,7.98,0,14.44,7.62,14.44,17.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElizaShipRight);
export default __webpack_public_path__ + "static/media/eliza-ship-right.9e866ca71797e6089f69c6c1299666b9.svg";
export { ForwardRef as ReactComponent };